"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisitTypeDto = exports.StatusDto = exports.AreaTypeDTO = exports.RecordTypeDTO = exports.CoverageEnumDTO = exports.ContingencyTypeDTO = exports.RecordStatusDTO = void 0;
var RecordStatusDTO;
(function (RecordStatusDTO) {
    RecordStatusDTO[RecordStatusDTO["Abierto"] = 0] = "Abierto";
    RecordStatusDTO[RecordStatusDTO["Cerrado"] = 1] = "Cerrado";
})(RecordStatusDTO = exports.RecordStatusDTO || (exports.RecordStatusDTO = {}));
var ContingencyTypeDTO;
(function (ContingencyTypeDTO) {
    ContingencyTypeDTO[ContingencyTypeDTO["Enfermedad_comun"] = 1] = "Enfermedad_comun";
    ContingencyTypeDTO[ContingencyTypeDTO["Accidente_no_laboral"] = 2] = "Accidente_no_laboral";
    ContingencyTypeDTO[ContingencyTypeDTO["Accidente_laboral_CB"] = 4] = "Accidente_laboral_CB";
    ContingencyTypeDTO[ContingencyTypeDTO["Enfermedad_profesional_CB"] = 5] = "Enfermedad_profesional_CB";
    ContingencyTypeDTO[ContingencyTypeDTO["Periodo_observacion_CB"] = 6] = "Periodo_observacion_CB";
    ContingencyTypeDTO[ContingencyTypeDTO["Accidente_laboral_SB"] = 7] = "Accidente_laboral_SB";
    ContingencyTypeDTO[ContingencyTypeDTO["Riesgo_durante_embarazo"] = 8] = "Riesgo_durante_embarazo";
    ContingencyTypeDTO[ContingencyTypeDTO["Riesgo_durante_lactancia"] = 9] = "Riesgo_durante_lactancia";
    ContingencyTypeDTO[ContingencyTypeDTO["Cuidado_hijos"] = 14] = "Cuidado_hijos";
    ContingencyTypeDTO[ContingencyTypeDTO["Cese_actividad_trabajadores_autonomos"] = 18] = "Cese_actividad_trabajadores_autonomos";
    ContingencyTypeDTO[ContingencyTypeDTO["Enfermedad_profesional_SB"] = 21] = "Enfermedad_profesional_SB";
    ContingencyTypeDTO[ContingencyTypeDTO["Periodo_observacion_SB"] = 23] = "Periodo_observacion_SB";
    ContingencyTypeDTO[ContingencyTypeDTO["Situacion_asimilada_accidente_trabajo"] = 24] = "Situacion_asimilada_accidente_trabajo";
    ContingencyTypeDTO[ContingencyTypeDTO["Prestacion_extraordinaria_cese_actividad"] = 25] = "Prestacion_extraordinaria_cese_actividad";
    ContingencyTypeDTO[ContingencyTypeDTO["Prestacion_ordinaria_extraordinaria__cese_actividad"] = 26] = "Prestacion_ordinaria_extraordinaria__cese_actividad";
    ContingencyTypeDTO[ContingencyTypeDTO["Prestacion_extraordinaria_de_temporada_cese_actividad"] = 27] = "Prestacion_extraordinaria_de_temporada_cese_actividad";
})(ContingencyTypeDTO = exports.ContingencyTypeDTO || (exports.ContingencyTypeDTO = {}));
var CoverageEnumDTO;
(function (CoverageEnumDTO) {
    CoverageEnumDTO[CoverageEnumDTO["ContingenciaComun"] = 1] = "ContingenciaComun";
    CoverageEnumDTO[CoverageEnumDTO["ContingenciaProfesional"] = 2] = "ContingenciaProfesional";
    CoverageEnumDTO[CoverageEnumDTO["CeseActividadTrabajadoresAutonomos"] = 3] = "CeseActividadTrabajadoresAutonomos";
})(CoverageEnumDTO = exports.CoverageEnumDTO || (exports.CoverageEnumDTO = {}));
var RecordTypeDTO;
(function (RecordTypeDTO) {
    // EnfermedadProf = 0,
    // Accidente = 1,
    // EnfermedadComun = 2
    RecordTypeDTO[RecordTypeDTO["HistorialConIT"] = 1] = "HistorialConIT";
    RecordTypeDTO[RecordTypeDTO["HistorialSinIT"] = 2] = "HistorialSinIT";
    RecordTypeDTO[RecordTypeDTO["HistorialCATA"] = 3] = "HistorialCATA";
    RecordTypeDTO[RecordTypeDTO["HistorialOficio"] = 4] = "HistorialOficio";
})(RecordTypeDTO = exports.RecordTypeDTO || (exports.RecordTypeDTO = {}));
var AreaTypeDTO;
(function (AreaTypeDTO) {
    AreaTypeDTO[AreaTypeDTO["Asistencial"] = 0] = "Asistencial";
    AreaTypeDTO[AreaTypeDTO["Econ\u00F3mico"] = 1] = "Econ\u00F3mico";
    AreaTypeDTO[AreaTypeDTO["Administrativo"] = 2] = "Administrativo";
    AreaTypeDTO[AreaTypeDTO["General"] = 3] = "General";
})(AreaTypeDTO = exports.AreaTypeDTO || (exports.AreaTypeDTO = {}));
var StatusDto;
(function (StatusDto) {
    StatusDto[StatusDto["Scheduled"] = 0] = "Scheduled";
    StatusDto[StatusDto["Done"] = 1] = "Done";
    StatusDto[StatusDto["Canceled"] = 2] = "Canceled";
    StatusDto[StatusDto["Modified"] = 3] = "Modified";
})(StatusDto = exports.StatusDto || (exports.StatusDto = {}));
var VisitTypeDto;
(function (VisitTypeDto) {
    VisitTypeDto[VisitTypeDto["EpisodioAmbulatorio"] = 0] = "EpisodioAmbulatorio";
    VisitTypeDto[VisitTypeDto["CentroExterno"] = 1] = "CentroExterno";
    VisitTypeDto[VisitTypeDto["Hospitalizacion"] = 2] = "Hospitalizacion";
    VisitTypeDto[VisitTypeDto["Imagen"] = 3] = "Imagen";
    VisitTypeDto[VisitTypeDto["Quirofano"] = 4] = "Quirofano";
    VisitTypeDto[VisitTypeDto["Rehabilitacion"] = 5] = "Rehabilitacion";
    VisitTypeDto[VisitTypeDto["Urgencia"] = 6] = "Urgencia";
    // Visit = 0,
    // Rehabilitation,
    // OperationRoom,
    // Hospitalization
})(VisitTypeDto = exports.VisitTypeDto || (exports.VisitTypeDto = {}));
;
